import { render, staticRenderFns } from "./LitterInfo.vue?vue&type=template&id=06f25196"
import script from "./LitterInfo.vue?vue&type=script&lang=ts"
export * from "./LitterInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports